import React from 'react';
import { format } from 'date-fns';
import { Event } from '../../api/client';

interface EventDetailsProps {
  event: Event;
}

const EventDetails: React.FC<EventDetailsProps> = ({ event }) => {
  return (
    <div className="space-y-3">
      <div>
        <h3 className="text-2xl font-bold">{event.title}</h3>
        {event.description && (
          <p className="text-gray-600 mt-2 whitespace-pre-wrap">{event.description}</p>
        )}
      </div>
      
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span className="text-gray-500">Date & Time:</span>
          <p className="font-medium">
            {format(new Date(event.date_time), 'PPp')}
            {event.end_time && ` - ${format(new Date(event.end_time), 'p')}`}
          </p>
        </div>
        <div>
          <span className="text-gray-500">Venue:</span>
          <a
            href={event.google_maps_link || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(event.venue)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-blue-600 hover:text-blue-800 transition-colors"
          >
            {event.venue}
          </a>
        </div>
        <div>
          <span className="text-gray-500">Type:</span>
          <p className="font-medium">{event.event_type.charAt(0).toUpperCase() + event.event_type.slice(1)}</p>
        </div>
        <div>
          <span className="text-gray-500">Capacity:</span>
          <p className="font-medium">{event.max_attendees} attendees</p>
        </div>
        <div>
          <span className="text-gray-500">Status:</span>
          <p className="font-medium">
            {event.approved_count}/{event.max_attendees} confirmed
            {event.reserved_tickets > 0 && ` (${event.reserved_tickets} reserved)`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;